export default "__VITE_ASSET__0xAHg7hv__"